<button (click)="open()">{{eiPopupButtonDefinition.label}}</button>
